import React from 'react';
import { Box, Card, Stack } from '@mui/material';
import CedisList from './CedisList';

// Pantalla simple sin tabs (patrón ListBranchOfficesScreen). Los insumos globales y sus
// categorías viven ahora en Catálogo 2.0; cada CEDIS conserva su propio inventario.
const CedisScreen: React.FunctionComponent = () => {
    return (
        <Box height="100%" p={4}>
            <Stack component={Card} height="100%">
                <CedisList />
            </Stack>
        </Box>
    );
};

export default CedisScreen;
